class Modal {
    private modals: NodeListOf<HTMLElement>;
    private openButtons: NodeListOf<HTMLElement>;
    private closeButtons: NodeListOf<HTMLElement>;

    constructor() {
        this.modals = document.querySelectorAll(".modal");
        this.openButtons = document.querySelectorAll(".open-modal");
        this.closeButtons = document.querySelectorAll(".close-modal");

        this._init();
    }

    private _init(): void {
        // Открытие модалки
        this.openButtons.forEach((button: HTMLElement) => {
            button.addEventListener("click", (e: Event) => {
                e.preventDefault(); // 🔥 важно для <a href="#">

                const modalId = button.getAttribute("data-modal");
                if (!modalId) return;

                this.open(modalId, button);
            });
        });

        // Закрытие по крестику
        this.closeButtons.forEach((button: HTMLElement) => {
            button.addEventListener("click", () => {
                this.close();
            });
        });

        // Закрытие по клику вне контента
        this.modals.forEach((modal: HTMLElement) => {
            modal.addEventListener("click", (e: MouseEvent) => {
                if (e.target === modal) {
                    this.close();
                }
            });
        });

        // Закрытие по Escape
        document.addEventListener("keydown", (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                this.close();
            }
        });
    }

    public open(modalId: string, trigger?: HTMLElement): void {
        this.close();

        const modal = document.getElementById(modalId);
        if (!modal) return;

        // 🔥 Подстановка данных из кнопки
        if (trigger) {
            const title = trigger.getAttribute("data-title");
            const description = trigger.getAttribute("data-description");

            const modalTitle = modal.querySelector<HTMLElement>(".modal-title");
            const modalText = modal.querySelector<HTMLElement>(".modal-text");
            const formTitleInput = modal.querySelector<HTMLInputElement>("#form-title");

            if (title && modalTitle) {
                modalTitle.textContent = title;
            }

            if (description && modalText) {
                modalText.textContent = description;
            }

            if (title && formTitleInput) {
                formTitleInput.value = title;
            }
        }

        modal.classList.add("show");
        document.body.classList.add("modal-open");
    }

    public close(): void {
        this.modals.forEach((modal: HTMLElement) => {
            modal.classList.remove("show");
        });

        document.body.classList.remove("modal-open");
    }
}

export const modal = new Modal();
(window as any).modal = modal;
